import { Controller } from 'stimulus';
import { prettyPrice, updateQuantity } from '../helpers/cartHelpers';

const runningUpdates = [];

const SHIPPING_COSTS_PROGRESS_ELEMENT = '.js-shipping-costs-progress';
const SHIPPING_COSTS_PROGRESS_CONTENT = '.js-shipping-costs-progress-content';
const SHIPPING_COSTS_PROGRESS_BAR_CONTAINER = '.js-shipping-costs-progress-bar-container';
const SHIPPING_COSTS_PROGRESS_BAR = '.js-shipping-costs-progress-bar';
const SHIPPING_COSTS_PROGRESS_REMAINING = '.js-shipping-costs-progress-remaining';
const SHIPPING_COSTS_PROGRESS_REMAINING_PERCENTAGE = '.js-shipping-costs-progress-remaining-percentage';

function getCartPage() {
  return $.ajax({
    url: '/winkelmand',
  });
}

function parseCartPage(res) {
  return $(res);
}

function getTextFromPage($elements, selector) {
  const $items = $elements.find(selector);

  if (!$items.length) {
    return null;
  }

  return $items.get(0).innerHTML.trim();
}

function stringToFloat(string) {
  if (string === null) {
    return 0;
  }

  return parseFloat(string.replace('€ ', '').replace(',', '.')).toFixed(2);
}

function updateShippingPriceProgressBar(total) {
  const minimumPriceForFreeShippingCosts = $(SHIPPING_COSTS_PROGRESS_ELEMENT).data('minimum-price');
  const remaining = minimumPriceForFreeShippingCosts - total;
  const remainingPercentage = (total / minimumPriceForFreeShippingCosts) * 100;

  $(SHIPPING_COSTS_PROGRESS_CONTENT).find('.is-finished').toggle(total >= minimumPriceForFreeShippingCosts);
  $(SHIPPING_COSTS_PROGRESS_CONTENT).find('.not-finished').toggle(total <= minimumPriceForFreeShippingCosts);

  $(SHIPPING_COSTS_PROGRESS_BAR_CONTAINER).toggle(total <= minimumPriceForFreeShippingCosts);

  $(SHIPPING_COSTS_PROGRESS_REMAINING).html(prettyPrice(remaining < 0 ? 0 : remaining, false));
  $(SHIPPING_COSTS_PROGRESS_BAR).css('width', `${remainingPercentage > 100 ? 100 : remainingPercentage}%`);
  $(SHIPPING_COSTS_PROGRESS_REMAINING_PERCENTAGE).text(`${remainingPercentage >= 100 ? 100 : remainingPercentage.toFixed()}%`);
}

function extractFromCartPage($elements) {
  const total = getTextFromPage($elements, '[data-target="cart.total"]');
  const couponValue = getTextFromPage($elements, '[data-target="cart.couponValue"]');
  updateShippingPriceProgressBar(stringToFloat(total) - stringToFloat(couponValue));

  return {
    subTotal: getTextFromPage($elements, '[data-target="cart.subTotal"]'),
    shippingCosts: getTextFromPage($elements, '[data-target="cart.shippingCosts"]'),
    couponValue,
    priceSchemeValue: getTextFromPage($elements, '[data-target="cart.priceSchemeValue"]'),
    total,
    taxValue: getTextFromPage($elements, '[data-target="cart.taxValue"]'),
  };
}

function randomNumber() {
  return Math.round(10000 + (Math.random() * 99999));
}

class Cart extends Controller {
  static updatePriceForItem(cartItem) {
    const quantityInput = cartItem.querySelector('[data-target*="cart.quantityInput"]');
    const priceOutput = cartItem.querySelector('[data-target="cart.cartItemPriceOutput"]');

    const quantity = parseInt(quantityInput.value, 10);
    const price = parseFloat(cartItem.getAttribute('data-price'));

    if (Number.isNaN(quantity) || Number.isNaN(price) || !priceOutput) {
      return 0;
    }

    priceOutput.innerHTML = prettyPrice(price * quantity, false);

    return price * quantity;
  }

  onQuantityChange(e) {
    const item = e.target.closest('[data-target="cart.cartItem"]');
    const quantity = e.target.value;
    const itemId = item.getAttribute('data-id');
    const price = parseFloat(item.getAttribute('data-price'));

    const priceOutput = item.querySelector('[data-target="cart.cartItemPriceOutput"]');

    if (priceOutput && !Number.isNaN(price) && !Number.isNaN(quantity)) {
      priceOutput.innerHTML = prettyPrice(price * quantity, false);
    }

    const randNum = randomNumber();

    // Keep track of which updates to the cart are happening.
    runningUpdates.push(randNum);

    requestAnimationFrame(() => {
      updateQuantity(itemId, quantity)
        .then(() => {
          // If this is not the last request that was fired, we wait to the next one
          const isLast = runningUpdates.indexOf(randNum) === (runningUpdates.length - 1);
          runningUpdates.splice(runningUpdates.indexOf(randNum), 1);

          if (isLast) {
            this.updatePrices();
          }
        });
    });
  }

  outputToCartPage(cartSpecifications) {
    this.subTotalTarget.innerHTML = cartSpecifications.subTotal;
    this.shippingCostsTarget.innerHTML = cartSpecifications.shippingCosts;
    this.totalTarget.innerHTML = cartSpecifications.total;

    if (this.targets.find('couponValue')) {
      this.couponValueTarget.innerHTML = cartSpecifications.couponValue;
    }

    if (this.targets.find('priceSchemeValue')) {
      this.priceSchemeValueTarget.innerHTML = cartSpecifications.priceSchemeValue;
      $(this.priceSchemeValueTarget).parent().toggle(cartSpecifications.priceSchemeValue !== '€ 0,00');
    }

    if (this.targets.find('taxValue')) {
      this.taxValueTarget.innerHTML = cartSpecifications.taxValue;
    }
  }

  updatePrices() {
    getCartPage()
      .then(parseCartPage)
      .then(extractFromCartPage)
      .then(this.outputToCartPage.bind(this));
  }
}

Cart.targets = [
  'quantityInput',
  'cartItem',
  'subTotal',
  'total',
  'shippingCosts',
  'couponValue',
  'priceSchemeValue',
  'taxValue',
];

export default Cart;
